import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, Input, ViewChild } from '@angular/core';
import { IPrintableReportHeading } from '@models/report-print-heading';
import { TranslateModule } from '@ngx-translate/core';
import { PreloaderModule } from '@shared/preloader/preloader.module';
import { ZbpDataTableComponent } from '@shared/zbp-data-table/zbp-data-table.component';
import { ZbpDataTable } from '@shared/zbp-data-table/zbp-data-table.model';
import { zbpIconNames } from '@shared/zbp-icon/zbp-icon-names';

@Component({
  selector: 'zbp-score-detail-view',
  standalone: true,
  imports: [
    CommonModule,
    ZbpDataTableComponent,
    PreloaderModule,
    TranslateModule,
  ],
  templateUrl: './score-detail-view.component.html',
  styleUrls: ['./score-detail-view.component.scss'],
})
export class ScoreDetailViewComponent implements AfterViewInit {
  // Headers
  @Input({ required: true }) studentName: string = '';
  @Input({ required: true }) className: string = '';
  @Input({ required: true }) productName: string = '';
  @Input({ required: true }) activityName: string = '';
  @Input() printableHeaders: IPrintableReportHeading[] = [];

  // Table Data
  @Input() columns: ZbpDataTable.Column[] = [];
  @Input() rows: ZbpDataTable.Row[] = [];

  // State
  @Input() showSpinner = false;

  @ViewChild(ZbpDataTableComponent) dataTable?: ZbpDataTableComponent;

  readonly zbpIconNames = zbpIconNames;

  ngAfterViewInit(): void {
    document.querySelectorAll('.checkmarkIcon').forEach(icon => icon.setAttribute('aria-label', 'correct'));
    document.querySelectorAll('.xCrossIcon').forEach(icon => icon.setAttribute('aria-label', 'incorrect'));
  }

  /**
   * Used by the container to expand all collapsible rows before printing.
   */
  expandAllCollapsibleRows(): void {
    this.dataTable?.expandAllCollapsibleRows();
  }

  /**
   * Used by the container to collapse all collapsible rows before printing fluency.
   */
  collapseAllCollapsibleRows(): void {
    this.dataTable?.collapseAllCollapsibleRows();
  }

  /**
   * Used by the container to restore collapsible row state after printing.
   */
  restoreCollapsibleRowStates(): void {
    this.dataTable?.restoreCollapsibleRowStates();
  }
}
